import React from 'react';
import PropTypes from 'prop-types';

import { enhance } from '../utils';
import TooltipStyled from '../styled';
import { injectIntl } from 'react-intl';
import { StyledCopyableText } from './styled';

const CopyableText = ({ className, text, copied, handleClick, intl }) => {
  const t = intl.messages.modules.copy.copyButton;
  return (
    (copied && (
      <TooltipStyled skin={'dark'} position="top" component={t.copied} alwaysVisible={copied}>
        <StyledCopyableText onClick={handleClick}>{text}</StyledCopyableText>
      </TooltipStyled>
    )) || (
      <StyledCopyableText onClick={handleClick} className={className}>
        {text}
      </StyledCopyableText>
    )
  );
};

CopyableText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  copied: PropTypes.bool,
};

export default enhance(injectIntl(CopyableText));
